export default __webpack_public_path__ + "static/media/01_Arch_Sonnenpark.051709fe.jpg";